import styled from "styled-components";

const options = {
  isClickable: {
    [true]: 1,
    [false]: 0.5,
  },
};

export const ActionsContainer = styled.div`
  display: grid;
  place-content: center;
  position: absolute;
  top: 0;
  bottom: 0;
  right: -17px;
  z-index: 20;
`;

export const ActionsColumnsContainer = styled.div`
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0px 1.171px 5.854px 0px rgba(63, 65, 66, 0.2);
  padding: 8px 6px;
  background-color: ${({ theme }) => theme.bg.secondary};
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const ActionsColumn = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 12px;
`;

export const ActionsColumnDivider = styled.div`
  width: 20px;
  display: block;
  height: 1px;
  background-color: ${({ theme }) => theme.border.black15};
  margin-block: 10px;
`;

export const ActionsButton = styled.button`
  background: none;
  display: grid;
  place-content: center;
  border: none;
  width: 20px;
  height: 20px;
  cursor: pointer;
  opacity: ${({ isClickable = true }) => options.isClickable[isClickable]};
  color: ${({ theme }) => theme.text.title};
`;
